export default __webpack_public_path__ + "static/media/front-page-image.3d050288.jpeg";